import { BydCleanInstance } from '@sixense/byd-clean-instance';
import { DsMapFiltersInterface } from '../interfaces/ds-map-filters.interface';

@BydCleanInstance
export class DsMapFilters {
  /**
   * The search term.
   */
  public search?: string;

  /**
   * The category id.
   */
  public categoryId?: number;

  /**
   * The page index.
   */
  public pageIndex?: number;

  /**
   * The elements per page.
   */
  public numPerPage?: number;

  /**
   * The order by.
   */
  public orderBy?: string;

  /**
   * The order sort.
   */
  public orderSort?: string;

  /**
   * Creates an instance of DsFormInstanceFilters.
   *
   * @param json form filters
   */
  constructor(json: DsMapFiltersInterface) {
    this.search = json.search;
    this.categoryId = json.categoryId;
    this.pageIndex = json.pageIndex;
    this.numPerPage = json.numPerPage;
    this.orderBy = json.orderBy;
    this.orderSort = json.orderSort;
  }
}
